import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
export const GET_ASSOCIATED_ACTION_TYPE_IDS = registerQuery({
  fieldName: 'actionTypeIds',
  args: ['actionTypeId'],
  fetcher: ({
    actionTypeId
  }) => http.get(`automation/v4/actions/internal/access/definitions/associated/${actionTypeId}`)
});